<template>
  <div class="irp-overview-tab" data-testid="irp-overview-tab">
    <IRPRecommendedPartnersTable class="min-w-0" />
    <aside class="irp-overview-tab__panels">
      <IRPKeyContactsPanel class="min-w-0" />
      <IRPRecentActivityPanel class="min-w-0" />
    </aside>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';

import { useIndividualRecordStore } from '@/stores';

import IRPKeyContactsPanel from './IRPKeyContactsPanel.vue';
import IRPRecentActivityPanel from './IRPRecentActivityPanel.vue';
import IRPRecommendedPartnersTable from './IRPRecommendedPartnersTable.vue';

const individualRecordStore = useIndividualRecordStore();

/* The page owns the record and the router reuses this instance across records,
   so the fetch follows the store rather than mount. `all` is the sectionless
   response the partners table reads. */
watch(
  () =>
    [
      individualRecordStore.sourceId,
      individualRecordStore.sourcePrimaryKey,
    ] as const,
  () => individualRecordStore.fetchSection('all'),
  { immediate: true },
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.irp-overview-tab {
  @apply flex flex-col gap-24;
}

.irp-overview-tab__panels {
  @apply grid grid-cols-1 gap-24 items-start lg:grid-cols-2;
}
</style>
